module.exports = __webpack_public_path__ + "static/img/image_home_product_04.d21bfb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_home_product_04.png
// module id = PBv3
// module chunks = 10